import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ValidationQueue from "./pages/ValidationQueue";
import Drafts from "./pages/Drafts";
import ContentLibrary from "./pages/ContentLibrary";
import ScientificWatch from "./pages/ScientificWatch";
import EditorialCalendar from "./pages/EditorialCalendar";
import LinkingGraph from "./pages/LinkingGraph";
import Performance from "./pages/Performance";
import EmailHistory from "./pages/EmailHistory";
import Strategy from "./pages/Strategy";
import Publication from "./pages/Publication";
import PublicPreview from "./pages/PublicPreview";
import Rejections from "./pages/Rejections";
import Newsletter from "./pages/Newsletter";

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/apercu/:id" element={<PublicPreview />} />
          <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
            <Route index element={<Dashboard />} />
            <Route path="validation" element={<ValidationQueue />} />
            <Route path="publication" element={<Publication />} />
            <Route path="brouillons" element={<Drafts />} />
            <Route path="contenus" element={<ContentLibrary />} />
            <Route path="rejets" element={<Rejections />} />
            <Route path="newsletter" element={<Newsletter />} />
            <Route path="veille" element={<ScientificWatch />} />
            <Route path="calendrier" element={<EditorialCalendar />} />
            <Route path="maillage" element={<LinkingGraph />} />
            <Route path="performance" element={<Performance />} />
            <Route path="emails" element={<EmailHistory />} />
            <Route path="strategie" element={<Strategy />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
